import { HistoryViewModel } from '../../support/HistoryViewModel';
import { IDrawerQueryParams } from './IDrawerQueryParams';

export class QueryParamDrivenDrawerHelper<TDrawerProps = {}>{
    static inject = () => [HistoryViewModel];
    constructor(private history: HistoryViewModel){}

    open = (params: IDrawerQueryParams & TDrawerProps) => {
        const path = this.history.getCurrentLocation().pathname;

        const searchParams = this.history.getCurrentSearchParams();

        const drawerSearchParams = this.buildQueryParams(params);
        for (const key of drawerSearchParams.keys()){
            searchParams.set(key, drawerSearchParams.get(key)!);
        }

        this.history.push(`${path}?${searchParams.toString()}`);
    };

    buildQueryParams = (params: IDrawerQueryParams & TDrawerProps) => {
        const searchParams = new URLSearchParams();
        searchParams.set('drawer', JSON.stringify(params));
        return searchParams;
    };

    close = () => {
        const path = this.history.getCurrentLocation().pathname;
        const searchParams = this.history.getCurrentSearchParams();
        searchParams.delete('drawer');

        this.history.push(`${path}?${searchParams.toString()}`);
    };
}
